import CityServiceStyles from './city-service';
import QuoteFlowFormLoader from '../quote-flow/Code/QuoteFlowForm/components/QuoteFlowFormLoader';

export default class CityService {
    constructor() {
        let editMode = document.querySelector('body.pagemode-edit');
        this.submitButton = document.querySelector('#CityServiceSubmit');
        this.proceedButton = document.querySelector('#CityServiceProceed');

        if(!editMode && this.submitButton) {
            this.attachSubmitEvent();
        } else if(!editMode && this.proceedButton) {
            this.querySelector('#CityServiceForm').submit();
        }
    }

    attachSubmitEvent() {
        if (this.submitButton) {
            this.submitButton.addEventListener("click", (e) => {
                this.renderMessages();
            });
        }
    }

    renderMessages() {
        if(document.querySelector('input[name="ContainerPlacementAnswer"]:checked'))
            this.ContainerPlacementAnswer = document.querySelector('input[name="ContainerPlacementAnswer"]:checked').value;
        if(document.querySelector('input[name="OnStreetPermitsAnswer"]:checked'))
            this.OnStreetPermitsAnswer = document.querySelector('input[name="OnStreetPermitsAnswer"]:checked').value;
        if(document.querySelector('input[name="ContainerClearanceAnswer"]:checked'))
            this.ContainerClearanceAnswer = document.querySelector('input[name="ContainerClearanceAnswer"]:checked').value;

        var arrAnswers = [this.ContainerPlacementAnswer.toLowerCase(), this.OnStreetPermitsAnswer.toLowerCase(), this.ContainerClearanceAnswer.toLowerCase()];
        if (arrAnswers.includes("yes")) {
            this.populateFormFields();
            document.getElementById('CityServiceSubmit').removeAttribute('href');
            document.getElementById('CityServiceSubmit').innerHTML = 'Please wait';
            document.getElementById('CityServiceForm').submit();
        } else if (arrAnswers.includes("notsure")) {
            this.hideForm();
            document.querySelector('#CallServiceCenter').style.display = "block";
        } else {
            window.location.href = document.getElementById('landingPage').value;
        }
    }

    hideForm() {
        if(document.querySelector('.split-image-component'))
            document.querySelector('.split-image-component').style.display='none';
        if(document.querySelector('#CityServiceSubmit'))
            document.querySelector('#CityServiceSubmit').style.display='none';
        if(document.querySelector('#CityServiceQuestionsWrapper'))
            document.querySelector('#CityServiceQuestionsWrapper').style.display='none';
        if(document.querySelector('#CityServiceActionWrapper'))
            document.querySelector('#CityServiceActionWrapper').style.display='block';
    }

    populateFormFields() {
        var obj = JSON.parse(sessionStorage['quoteInfo']);
        document.getElementById('quoteType').value = obj.quoteType;
        document.getElementById('businessType').value = obj.quoteType == "residential" ? "Residential" : "Commercial";
        document.getElementById('serviceType').value = obj.serviceType;
        document.getElementById('originZipCode').value = obj.originZipCode;
        document.getElementById('originCity').value = JSON.stringify(obj.originCity);
        if (obj.destinationZipCode || obj.destinationCity) {
            document.getElementById('destinationZipCode').value = obj.destinationZipCode;
            document.getElementById('destinationCity').value = JSON.stringify(obj.destinationCity);
        } else {
            document.getElementById('destinationZipCode').value = document.getElementById('originZipCode').value;
            document.getElementById('destinationCity').value = document.getElementById('originCity').value;
        }
        document.getElementById('selectedDate').value = new Date(parseInt(obj.selectedDate));
        document.getElementById('selectedDate_display').value = obj.selectedDate_display;
        document.getElementById('emailAddress').value = obj.emailAddress;
        document.getElementById('duration').value = obj.duration;
        document.getElementById('promotionCode').value = obj.promotionCode;
        document.getElementById('moveType').value = obj.moveType;
        document.getElementById('storingLocation').value = obj.storingLocation;
        document.getElementById('contactId').value = obj.contactId;
        document.getElementById('contactIp').value = obj.contactIp;
        document.getElementById('erpService').value = obj.erpService;
        document.getElementById('PodsPhone').value = obj.PodsPhone;
        document.getElementById('hdnSixteenFootIsAvailable').value = obj.hdnSixteenFootIsAvailable;
        document.getElementById('hdnTwelveFootIsAvailable').value = obj.hdnTwelveFootIsAvailable;
        document.getElementById('hdnSevenFootIsAvailable').value = obj.hdnSevenFootIsAvailable;
    }
}
